/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ClientSideAvailabilityPost = {
  /**
   * Whether to enable availability for client-side SDKs. Defaults to <code>false</code>.
   */
  usingEnvironmentId: boolean;
  /**
   * Whether to enable availability for mobile SDKs. Defaults to <code>true</code>.
   */
  usingMobileKey: boolean;
};

/** @internal */
export const ClientSideAvailabilityPost$inboundSchema: z.ZodType<
  ClientSideAvailabilityPost,
  z.ZodTypeDef,
  unknown
> = z.object({
  usingEnvironmentId: z.boolean(),
  usingMobileKey: z.boolean(),
});
/** @internal */
export type ClientSideAvailabilityPost$Outbound = {
  usingEnvironmentId: boolean;
  usingMobileKey: boolean;
};

/** @internal */
export const ClientSideAvailabilityPost$outboundSchema: z.ZodType<
  ClientSideAvailabilityPost$Outbound,
  z.ZodTypeDef,
  ClientSideAvailabilityPost
> = z.object({
  usingEnvironmentId: z.boolean(),
  usingMobileKey: z.boolean(),
});

export function clientSideAvailabilityPostToJSON(
  clientSideAvailabilityPost: ClientSideAvailabilityPost,
): string {
  return JSON.stringify(
    ClientSideAvailabilityPost$outboundSchema.parse(clientSideAvailabilityPost),
  );
}
export function clientSideAvailabilityPostFromJSON(
  jsonString: string,
): SafeParseResult<ClientSideAvailabilityPost, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ClientSideAvailabilityPost$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ClientSideAvailabilityPost' from JSON`,
  );
}
